import { CanActivateChildFn, CanActivateFn, UrlTree, Router } from '@angular/router';
import { inject } from '@angular/core';
import { CredentialsService } from '../data-access/credentials.service';

function protect(url: string): boolean | UrlTree {
    const credentialsService = inject(CredentialsService);
    if (credentialsService.isAuthenticated()) {
        return true;
    }

    return inject(Router).createUrlTree(['/auth/login'], {
        queryParams: { redirect: url }
    });
}

export const authenticationGuard: CanActivateFn = (_route, state) => protect(state.url);
export const authenticationChildGuard: CanActivateChildFn = (_route, state) => protect(state.url);
